import 'svelte/internal/disclose-version';
import 'svelte/internal/flags/legacy';
import * as $ from 'svelte/internal/client';
import TopBar from '../components/layout/TopBar.svelte';
import Card from '../components/shared/Card.svelte';
import { navigate } from '../lib/router.svelte.ts';

var root_2 = $.from_html(`<div class="menu-item svelte-3m9v49ajv9b2u"><span class="menu-icon svelte-3m9v49ajv9b2u"> </span> <span class="menu-label svelte-3m9v49ajv9b2u"> </span> <svg class="menu-chevron svelte-3m9v49ajv9b2u" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M9 18l6-6-6-6"></path></svg></div>`);
var root = $.from_html(`<!> <div class="more-page svelte-3m9v49ajv9b2u"></div>`, 1);

function More($$anchor, $$props) {
	$.push($$props, false);

	const items = [
		{ icon: '👶', label: 'Manage children', path: '/more/children' },
		{ icon: '💚', label: 'Baby Care', path: '/health' },
		{ icon: '📊', label: 'Analytics', path: '/analytics' },
		{ icon: '🔔', label: 'Reminders', path: '/reminders' },
		{ icon: '🔄', label: 'Partner Sync', path: '/sync' },
		{ icon: '💛', label: 'Donate', path: '/donate' },
		{ icon: '💾', label: 'Backup & Export', path: '/export' },
		{ icon: '⚙️', label: 'Settings', path: '/more/settings' }
	];

	$.init();

	var fragment = root();
	var node = $.first_child(fragment);

	TopBar(node, { title: 'More' });

	var div = $.sibling(node, 2);

	$.each(div, 5, () => items, $.index, ($$anchor, item) => {
		var fragment_1 = $.comment();
		var node_1 = $.first_child(fragment_1);

		Card(node_1, {
			onclick: () => navigate($.get(item).path),
			children: ($$anchor, $$slotProps) => {
				var div_1 = root_2();
				var span = $.child(div_1);
				var text = $.child(span, true);

				$.reset(span);

				var span_1 = $.sibling(span, 2);
				var text_1 = $.child(span_1, true);

				$.reset(span_1);
				$.next(2);
				$.reset(div_1);

				$.template_effect(() => {
					$.set_text(text, $.get(item).icon);
					$.set_text(text_1, $.get(item).label);
				});

				$.append($$anchor, div_1);
			},
			$$slots: { default: true }
		});

		$.append($$anchor, fragment_1);
	});

	$.reset(div);
	$.append($$anchor, fragment);
	$.pop();
}

if (import.meta.hot) {
	More = $.hmr(More);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-3m9v49ajv9b2u');
		More[$.HMR].update(module.default);
	});
}

export default More;
import "bun-svelte:More.svelte-3v6o12zdnk7g1-style.css";